import React from 'react';
import { Text } from '@react-pdf/renderer';

import _ from 'lodash';

import GeneralPageLayout from './GeneralPageLayout';

const GuideCover = ({
  primaryBrand,
  themeData,
  relevantFeatureLogics,
  uuid,
}): JSX.Element => {
  const Concerns = 
    _.map(
      relevantFeatureLogics,
      (featureLogic, i) => {
        return <Text style={{
          fontFamily: 'Courier',
          fontSize: 14,
          lineHeight: 1.12,
        }} key={ i }>• { featureLogic.description }</Text>;
      }
    );

  return (
    <GeneralPageLayout
      sectionTypeText="Clinical Guides"
      sectionTitleText={themeData.name}
      textColor={primaryBrand.colors.dark}
      backgroundColor="white"
      footerText={uuid}
    >
      <Text>The following clinical guides were written to address the following concerns:</Text>
      { Concerns }
    </GeneralPageLayout>
  );
};

export default GuideCover;
